export const siteData = {
  brand: {
    name: "Split Decisions",
    tagline: "Bar",
    heroTagline: "Some Decisions Shouldn't Be Easy",
    heroSubheading: "A full-service bar in Ansonia, CT — where the drinks are strong, the company's better, and the choices are never simple.",
    ctaLeft: "Plan Your Night",
    ctaRight: "See the Vibe",
  },
  features: [
    { title: "Pool Tournaments", description: "Rack 'em up. Weekly tournaments with bragging rights on the line." },
    { title: "Live Music & DJs", description: "The soundtrack changes nightly. The energy doesn't." },
    { title: "Outdoor Space", description: "Fresh air, cold drinks, good company. Step outside and stay a while." },
    { title: "Big Screens", description: "Flatscreens everywhere. Catch every play, every round, every highlight." },
    { title: "Happy Hour", description: "Monday through Friday, 4 to 8 — 2-for-1 drinks. The easiest decision you'll make all night." },
    { title: "Full Bar", description: "From top-shelf to tap. Whatever you're drinking, we've got it covered." }
  ],
  about: {
    title: "Welcome to Split Decisions",
    paragraphs: [
      "Split Decisions is a full-service bar located on Water Street in Ansonia, CT. Pool, live music, big screens, a stacked bar, and good people — it's all here.",
      "El & Drae had a vision and turned it into a reality."
    ],
    highlight: "Come through. Have a drink. Have a great time."
  },
  gallery: {
    title: "The Vibe",
    subtitle: "Step inside. See what's waiting.",
    images: [
      { src: "/images/interior-1.jpg", alt: "Pool table and bar area", caption: "Rack 'em up" },
      { src: "/images/interior-2.jpg", alt: "Bar counter and seating", caption: "Pull up a seat" },
      { src: "/images/interior-3.jpg", alt: "Blue-lit bar atmosphere", caption: "The glow up" },
      { src: "/images/interior-4.jpg", alt: "Full bar area", caption: "Where the night starts" },
      { src: "/images/logo.jpg", alt: "Split Decisions Logo", caption: "The emblem" }
    ]
  },
  visit: {
    title: "Find Us",
    subtitle: "The only hard part is deciding when to leave.",
    address: {
      line1: "8 Water Street",
      line2: "Ansonia, Connecticut 06401"
    },
    phone: "203-584-7325",
    email: "info@splitdecisionsbar.com",
    hours: [
      { days: "Monday – Friday", time: "4 PM – 1 AM" },
      { days: "Saturday", time: "6 PM – 2 AM" },
      { days: "Sunday", time: "Varies · Opens early for game days" }
    ],
    happyHour: {
      days: "Monday – Friday · 4 PM – 8 PM",
      deal: "2-for-1 Drinks"
    },
    mapsUrl: "https://www.google.com/maps/place/8+Water+St,+Ansonia,+CT+06401",
    reservations: "Walk-ins always welcome. Planning a party, private event, or pool tournament? Hit us up — we'll make it happen.",
    social: {
      instagram: "https://instagram.com/splitdecisionsbar",
      facebook: "https://facebook.com/splitdecisionsbar",
      tiktok: "https://tiktok.com/@splitdecisionsbar"
    }
  },
  footer: {
    tagline: "Two guys. One bar. Your call.",
    copyright: `\u00a9 ${new Date().getFullYear()} Split Decisions Bar. All rights reserved.`
  }
};
